import { NavLink } from "react-router-dom";
import routeUrls from "../COMPONENTS/navbar/navLink";
import "../CSS/tripDetail.scss";
import { usePageBackground } from "../COMPONENTS/usePageBackground";

interface Entry {
  content: string;
  imageUrl?: string | null;
  imageUrls?: string[] | null;
  timestamp?: any;
}

// Legacy entries stored a single `imageUrl`; new ones use `imageUrls`.
const imagesOf = (entry: Entry): string[] =>
  entry.imageUrls ?? (entry.imageUrl ? [entry.imageUrl] : []);

interface Trip {
  title: string;
  location: string;
  date: string;
  imageUrl?: string | null;
  content?: string;
  entries?: Entry[];
}

export const TripDetailView = ({ trip }: { trip: Trip }) => {
  usePageBackground();
  const rawEntries = trip.entries || (trip.content ? [{ content: trip.content }] : []);
  const entries = [...rawEntries].reverse();

  const formatDate = (timestamp: any) => {
    if (!timestamp) return null;
    try {
      const date = timestamp.toDate?.() || new Date(timestamp);
      return date.toLocaleDateString();
    } catch {
      return null;
    }
  };

  return (
    <div className="trip">
      <div className="trip__inner">
        <NavLink to={routeUrls.BLOGG} className="trip__back">← Alla resor</NavLink>
        {trip.imageUrl && <div className="trip__hero" style={{ backgroundImage: `url(${trip.imageUrl})` }} />}
        <div className="trip__head">
          <span className="trip__location">{trip.location}</span>
          <h1 className="trip__title">{trip.title}</h1>
          <span className="trip__date">{trip.date}</span>
        </div>

      <div className="trip__body">
        {entries.map((entry, i) => {
          const dateStr = formatDate(entry.timestamp);
          return (
            <div key={i} className="trip__entry">
              {dateStr && <p className="trip__entry-date">{dateStr}</p>}
              {entry.content.split("\n\n").map((para, j) => (
                <p key={j}>{para}</p>
              ))}
              {imagesOf(entry).map((url, k) => (
                <img key={k} src={url} className="trip__entry-img" alt="" />
              ))}
            </div>
          );
        })}
      </div>
      </div>
    </div>
  );
};
